import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6

import PodReport from "../events/PodReport";

import Tags from "../Tags/EventTags"


import AttendeeGroup from "../events/AttendeeGroup";
import CopyEvent from "../events/CopyEvent";
import SpeedNetworkingSettings from "../events/SpeedNetworkingSettings";

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"

import ImageUploader from "../imageuploader";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const modules={
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction

    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
    ['link'],

    ['clean']     
  ],
}


const UpdateVirtualOffice = (props) => {

    console.log(props)
    const listVirtualOffice = (e) => {
        props.setUpdateOrCreate("n")
      }


    const [event, setEvent] = useState()  //set all service to blog
    const [title, setTitle] = useState();
    const [description, setDescription] = useState("");
    const [img, setImg] = useState();
    const [starttime, setStarttime] = useState(new Date());
    const [endtime, setEndtime] = useState(new Date());
    const [url, setUrl] = useState();   
    const [email, setEmail] = useState();
    const [location, setLocation] = useState();
    const [accessLevel, setAccessLevel] = useState();
    const [emailBlurb, setEmailBlurb] = useState();
    const [useBBBooking, setUseBBBooking] = useState();
    const [published, setPublished] = useState();    
    const [linkText, setLinkText] = useState(); 
    const [eventAttendees, setEventAttendees] = useState([]); 
    const [lipodRecords, setLipodRecords] = useState([]);
    const [copyOn, setCopyOn] = useState(false)
    const [viewReport, setViewReport] = useState(false);
    const [welcomeCallBlockExemption, setWelcomeCallBlockExemption] = useState();
    const [graduateOnly, setGraduateOnly] = useState();

    // Add attendee by email
    const [addEmail, setAddEmail] = useState("");
    const [addEmailError, setAddEmailError] = useState("");
    const [addEmailBusy, setAddEmailBusy] = useState(false);

    // Add/edit a pod link on behalf of an attendee
    const [linkAttendee, setLinkAttendee] = useState(null);
    const [linkValue, setLinkValue] = useState("");
    const [linkConfirm, setLinkConfirm] = useState(false);
    const [linkError, setLinkError] = useState("");
    const [linkBusy, setLinkBusy] = useState(false);

    useEffect(() => {
      apiGet(`intranetevents/geteventbyid/?id=${props.id}`).then(res => {
        res.json().then(data => {
          console.log(data.results[0])
            setEvent(data.results[0])
            setImg(data.results[0].img)
            setTitle(data.results[0].title)
            setUrl(data.results[0].url)
            setEmail(data.results[0].email)
            setLinkText(data.results[0].linktext)
            setDescription(data.results[0].description)
            setPublished(data.results[0].published)
            setStarttime(new Date(data.results[0].starttime))
            setEndtime(new Date(data.results[0].endtime))
            setLocation(data.results[0].location)
            setAccessLevel(data.results[0].accesslevel)
            setEmailBlurb(data.results[0].emailblurb)
            setUseBBBooking(data.results[0].usebbbooking)
            setWelcomeCallBlockExemption(data.results[0].welcome_call_block_exemption)
            setGraduateOnly(data.results[0].graduate_only)
        })
      })

      apiGet(`intranetevents/geteventattendees/?eventid=${props.id}`).then(res => {
        res.json().then(data => {
          setEventAttendees(data)
        })
      })

      apiGet(`intranetevents/getlipodrecords/?eventid=${props.id}`).then(res => {
        res.json().then(data => {
          setLipodRecords(data)
        })
      })
    }, [])

    function refreshAttendees(){
      setEventAttendees([])
      setLipodRecords([])
      apiGet(`intranetevents/geteventattendees/?eventid=${props.id}`).then(res => {
        res.json().then(data => {
          setEventAttendees(data)
        })
      })

      apiGet(`intranetevents/getlipodrecords/?eventid=${props.id}`).then(res => {
        res.json().then(data => {
          setLipodRecords(data)
        })
      })
    }

    function addAttendeeByEmail(){
      const email = addEmail.trim()
      if(!email){
        setAddEmailError("Please enter an email address")
        return
      }
      setAddEmailBusy(true)
      setAddEmailError("")
      apiPost(`intranetevents/addattendeebyemail`, { eventid: event.id, email: email })
        .then(res => res.json())
        .then(data => {
          setAddEmailBusy(false)
          if(data.status === "ok"){
            setAddEmail("")
            refreshAttendees()
          }else{
            setAddEmailError(data.error || "Could not add attendee")
          }
        })
        .catch(err => { console.log(err); setAddEmailBusy(false); setAddEmailError("Something went wrong") })
    }

    function openLinkModal(attendee){
      setLinkAttendee(attendee)
      setLinkValue(attendee.link || "")
      setLinkConfirm(false)
      setLinkError("")
    }

    function closeLinkModal(){
      setLinkAttendee(null)
      setLinkValue("")
      setLinkConfirm(false)
      setLinkError("")
    }

    function saveAttendeeLink(){
      const url = linkValue.trim()
      if(!url){
        setLinkError("Please enter a link")
        return
      }
      const hasExisting = !!(linkAttendee && linkAttendee.link)
      if(hasExisting && !linkConfirm){
        setLinkError("Tick the confirmation box to replace this member's existing link")
        return
      }
      setLinkBusy(true)
      setLinkError("")
      apiPost(`intranetevents/setattendeelink`, { joinedeventid: linkAttendee.id, url: url, overwrite: hasExisting })
        .then(res => res.json())
        .then(data => {
          setLinkBusy(false)
          if(data.status === "ok"){
            closeLinkModal()
            refreshAttendees()
          }else if(data.status === "needsconfirm"){
            setLinkError("This member already has a link. Tick the box to confirm replacing it.")
            setLinkConfirm(false)
          }else{
            setLinkError(data.error || "Could not save link")
          }
        })
        .catch(err => { console.log(err); setLinkBusy(false); setLinkError("Something went wrong") })
    }



    const submitForm = (exit) => {
        

        const body = {
          id: event.id,
          title: title,
          description: description,
          img: img ? img.replace(process.env.REACT_APP_AWS_LOCATION,"") : img,
          starttime: starttime.toISOString(),
          endtime: endtime.toISOString(),
          url: url,
          email: email,
          linktext: linkText,
          published: published,
          accesslevel: accessLevel,
          location: location,
          emailblurb: emailBlurb,
          usebbbooking: useBBBooking,
          welcome_call_block_exemption: welcomeCallBlockExemption,
          graduate_only: graduateOnly
        }

        apiPost(`intranetevents/updateevent`, body)
          .then(response => {if(exit){props.setUpdateOrCreate("n")}})
          .catch( err => console.log(err) )
  }

    if(event){
      return (
        <>
          <Container>
            <Row>
            <Col md={6}>
              <h1>Update - {event.id}</h1>
              </Col>
              <Col md={6} style={{textAlign: "right"}}><Button onClick={() => {submitForm(false);setCopyOn(true)}}>Copy Event</Button></Col>
            </Row>
              <Form onSubmit={submitForm}>
                <div className="section">
                <Row>
                <Col md={6}>
                    <Form.Group controlId="blogCreate.title">
                      <Form.Label>Title</Form.Label>
                      <Form.Control onChange={(event) => setTitle(event.target.value)} type="text" value={title} />
                    </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Check checked={published} onChange={(event) => {setPublished(event.target.checked)}} label="Published" />
                </Col>
                <Col md={2}>
                  <Form.Check checked={useBBBooking} onChange={(event) => {setUseBBBooking(event.target.checked)}} label="Use BB Booking" />
                </Col>
                <Col md={2}>
                  <Form.Check checked={welcomeCallBlockExemption} onChange={(event) => {setWelcomeCallBlockExemption(event.target.checked)}} label="Exempt from Welcome Call block" />
                </Col>
                <Col md={2}>
                  <Form.Check checked={graduateOnly} onChange={(event) => {setGraduateOnly(event.target.checked)}} label="Graduate Event" />
                </Col>
            </Row>
            <Row>
            <Col md={6}>
                    <Form.Group controlId="blogCreate.image">
                      <Form.Label>Image URL</Form.Label>
                      <Form.Control onChange={(event) => setImg(event.target.value)} type="text" value={img} />
                    </Form.Group>
                    <ImageUploader dirname="voimages" width={1200} height={628} filename={`vo${event.id}`} filetype={"JPEG"} setImageLocation={(url => setImg(url))} />
                    Please ensure all uploaded images are 1200 x 628
                </Col>
                <Col md={6}>
                    <Form.Group controlId="blogCreate.url">
                      <Form.Label>Registration URL</Form.Label>
                      <Form.Control onChange={(event) => setUrl(event.target.value)} type="text" value={url} />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group controlId="blogCreate.email">
                      <Form.Label>Location</Form.Label>
                      <Form.Control onChange={(event) => setLocation(event.target.value)} type="text" value={location} />
                      Leave blank for Online
                    </Form.Group>
                </Col> 
                <Col md={6}>
                    <Form.Group controlId="blogCreate.linktext">
                      <Form.Label>Button Text</Form.Label>
                      <Form.Control value={linkText} onChange={(event) => setLinkText(event.target.value)} as="select">
                      <option value="Register">Register</option>
                      <option value="Join">Join</option>
                      
                    </Form.Control>
                    </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="exampleForm.ControlSelect1">
                    <Form.Label>Access Level</Form.Label>
                    <Form.Control value={accessLevel} onChange={(event) => setAccessLevel(event.target.value)} as="select">
                      <option value="0">Everyone</option>
                      <option value="1">Members Only</option>
                      
                    </Form.Control>
                  </Form.Group>
                </Col>
            </Row>
            <Row>
            <Col md={6}>
                <Form.Group controlId="blogCreate.date">
                      <Form.Label>Start Time</Form.Label>
                      <DatePicker 
                        selected={starttime} 
                        onChange={(date) => setStarttime(date)}
                        showTimeSelect
                        locale="enGB"
                        dateFormat='dd/MM/yyyy HH:mm'
                       />
                      
                    </Form.Group>   
            </Col>
            <Col md={6}>
                    <Form.Group controlId="blogCreate.date">
                      <Form.Label>End Time</Form.Label>
                      <DatePicker 
                        selected={endtime} 
                        onChange={(date) => setEndtime(date)}
                        showTimeSelect
                        locale="enGB"
                        dateFormat='dd/MM/yyyy HH:mm'
                       />
                    </Form.Group> 
            </Col>
            </Row>
            <Row>
                <Col md={6}>
                <h4>Description</h4>
                  <ReactQuill style={{marginBottom:"100px", height:"300px"}}
                      value={description}
                      onChange={setDescription}
                      modules={modules}
                  />
                </Col>
                <Col md={6}>
                <Col md={6}>
                    <Form.Group controlId="blogCreate.emailblurb">
                      <Form.Label>Email Blurb</Form.Label>
                      <Form.Control value={emailBlurb} onChange={(event) => setEmailBlurb(event.target.value)} rows={8} as="textarea">
                      
                      
                    </Form.Control>
                    </Form.Group>
                </Col> 
                </Col>
                  
            </Row>
            
            <Button onClick={() => submitForm(false)} style={{marginBottom:"30px"}} className="btn btn-primary">
                    Save
                  </Button>
                  <Button onClick={() => submitForm(true)} style={{marginBottom:"30px"}} className="btn btn-primary">
                    Save and Exit
                  </Button>
                  <Button onClick={(event) => listVirtualOffice(event)} style={{marginBottom:"30px"}}  className="btn btn-primary">
                    Go back
                  </Button>
                </div>

                {event.eventtype === 7 && <SpeedNetworkingSettings event={event} starttime={starttime} endtime={endtime} />}

                <Tags eventId={event.id} />

            <div className="section">
              <Row>
                <Col xs={6}><h2>Event Attendees</h2></Col>
                <Col xs={3} style={{textAlign:"right"}}><Button onClick={refreshAttendees}>Refresh Attendees</Button></Col>
                {event.eventtype === 9 && <Col xs={3} style={{textAlign:"right"}}><Button onClick={() => setViewReport(true)}>View Report</Button></Col>}

              </Row>

              <Row style={{marginBottom:"15px"}}>
                <Col md={6}>
                  <Form.Group controlId="attendee.addByEmail">
                    <Form.Label>Add attendee by email</Form.Label>
                    <div style={{display:"flex"}}>
                      <Form.Control
                        type="email"
                        placeholder="name@example.com"
                        value={addEmail}
                        onChange={(e) => setAddEmail(e.target.value)}
                      />
                      <Button type="button" style={{marginLeft:"10px", whiteSpace:"nowrap"}} disabled={addEmailBusy} onClick={addAttendeeByEmail}>
                        {addEmailBusy ? "Adding..." : "Add"}
                      </Button>
                    </div>
                    {addEmailError && <Form.Text style={{color:"red"}}>{addEmailError}</Form.Text>}
                  </Form.Group>
                </Col>
              </Row>


            <Row>
              <Col>
                <Table>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Email</th>
                        {event.eventtype === 7 && <>
                        <th>Name</th>
                        <th>Type</th></>}
                        {event.eventtype === 9 && <>
                        <th>Group</th>
                        <th>Link Added?</th>
                        <th>Posts Engaged With</th>
                        <th></th></>}
                      </tr>
                    </thead>
                  {eventAttendees.map(attendee => {
                    let total_engagements = eventAttendees.filter(att => (att.group === attendee.group && att.link)).length - 1;
                    if(total_engagements < 0){
                      total_engagements = 0;
                    }


                    return (
                      <>
                      <tr>
                        <td>{attendee.auth0sub}</td>
                        <td>{attendee.email}</td>
                        {event.eventtype === 7 && <>
                        <td>{attendee.name}</td>
                        <td>{attendee.guest ? "Guest" : "Member"}</td></>}
                        {event.eventtype === 9 && <td>
                          <AttendeeGroup eventid={event.id} attendee={attendee} />
                          
                        </td>}
                        {event.eventtype === 9 && <td>{attendee.link ? <a href={attendee.link}>Link Added</a> : "No Link"}</td>}
                        {event.eventtype === 9 && <td>{lipodRecords.filter(record => record.judgingauth0sub === attendee.auth0sub).length}/{total_engagements}</td>}
                        {event.eventtype === 9 && <td><Button type="button" size="sm" onClick={() => openLinkModal(attendee)}>{attendee.link ? "Edit Link" : "Add Link"}</Button></td>}
                      </tr>
                      
                      </>)
                  })}
                </Table>
              </Col>

                
            </Row>
            

            <h2>Email list</h2>
                  <Row>
                    <Col>
                      {eventAttendees.map(attendee => `${attendee.email}; `)}
                    </Col>
                    
                  </Row>
            </div>
                
              </Form>
              
          </Container>

          <CopyEvent setCopyOn={(val) => setCopyOn(val)} copyOn={copyOn} originalEventId={event.id} originalStartTime={starttime} originalEndTime={endtime} />

          <Modal dialogClassName="event-report-modal" animation={false} show={viewReport} onHide={() => setViewReport(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Engagement Pod Report</Modal.Title>
              </Modal.Header>
              <Modal.Body><PodReport eventid={event.id} attendees={eventAttendees} records ={lipodRecords} /></Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setViewReport(false)}>
                  Exit
                </Button>

              </Modal.Footer>
          </Modal>

          <Modal show={!!linkAttendee} onHide={closeLinkModal}>
              <Modal.Header closeButton>
                <Modal.Title>{linkAttendee && linkAttendee.link ? "Edit Link" : "Add Link"}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {linkAttendee && <>
                  <p>Setting the post link on behalf of <strong>{linkAttendee.email || linkAttendee.auth0sub}</strong>.</p>
                  <Form.Group controlId="podLink.url">
                    <Form.Label>Post link</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="https://www.linkedin.com/posts/..."
                      value={linkValue}
                      onChange={(e) => setLinkValue(e.target.value)}
                    />
                  </Form.Group>
                  {linkAttendee.link && <>
                    <p style={{color:"red", marginTop:"10px"}}>This member already added their own link. Replacing it will overwrite their submission.</p>
                    <Form.Check
                      checked={linkConfirm}
                      onChange={(e) => setLinkConfirm(e.target.checked)}
                      label="I understand this will replace the member's existing link"
                    />
                  </>}
                  {linkError && <p style={{color:"red", marginTop:"10px"}}>{linkError}</p>}
                </>}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  disabled={linkBusy || !!(linkAttendee && linkAttendee.link && !linkConfirm)}
                  onClick={saveAttendeeLink}
                >
                  {linkBusy ? "Saving..." : "Save Link"}
                </Button>
                <Button variant="secondary" onClick={closeLinkModal}>
                  Cancel
                </Button>
              </Modal.Footer>
          </Modal>

        </>
      );
    }else{
      return <>Loading </>
    }
    

}

export default UpdateVirtualOffice;